import React from "react";
import diamondImage from "../assets/images/diamond.png";
import rcoinImage from "../assets/images/rcoin.png";
import noImage from "../assets/images/noImage.png";

const DailyTaskRewardItem = ({ reward }) => {
  const rewardImage =
    reward.type === "diamond"
      ? diamondImage
      : reward.type === "rcoin"
        ? rcoinImage
        : reward.item?.imagePreview || reward.item?.image || noImage;
  const rewardName =
    reward.type === "diamond"
      ? "Diamond"
      : reward.type === "rcoin"
        ? "VCoin"
        : reward.item?.name || reward.type;
  const validity = reward.validity
    ? `, ${reward.validity} ${reward.validityType}`
    : "";

  return (
    <div
      className="d-flex flex-column justify-content-center align-items-center gap-1"
      title={`${rewardName}: ${reward.quantity}${validity}`}
    >
      <img
        src={rewardImage}
        alt={rewardName}
        height="45px"
        width="auto"
        style={{ maxWidth: "60px", objectFit: "contain" }}
        onError={(event) => {
          event.currentTarget.onerror = null;
          event.currentTarget.src = noImage;
        }}
      />
      <span>x{reward.quantity}</span>
      {reward.validity && (
        <small>
          {reward.validity}
          {reward.validityType?.slice(0, 1)}
        </small>
      )}
    </div>
  );
};

export default DailyTaskRewardItem;
